(function() { window.GUID_a66e4c25_4140_4ec8_9d02_12d1c549b5a2 = { getGuid: function() { return "a66e4c25-4140-4ec8-9d02-12d1c549b5a2"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PictureType;
        (function (PictureType) {
            PictureType[PictureType["Player"] = 0] = "Player";
            PictureType[PictureType["Team"] = 1] = "Team";
            PictureType[PictureType["Event"] = 2] = "Event";
            PictureType[PictureType["NewsFeed"] = 3] = "NewsFeed";
        })(PictureType = Enumeration.PictureType || (Enumeration.PictureType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PictureType.pre.js.map
